// Lista de proyectos filtrable por status. Click → onSelect(projectId).

import { useState } from 'react';

import { useProjects } from '../hooks/useProjects';
import type { ProjectStatus } from '../types';

const STATUS_OPTIONS: { value: '' | ProjectStatus; label: string }[] = [
  { value: '', label: 'Todos' },
  { value: 'active', label: 'Activos' },
  { value: 'on_hold', label: 'En pausa' },
  { value: 'completed', label: 'Completados' },
  { value: 'cancelled', label: 'Cancelados' },
];

interface Props {
  selectedId: string | null;
  onSelect: (projectId: string) => void;
}

export function ProjectList({ selectedId, onSelect }: Props) {
  const [status, setStatus] = useState<'' | ProjectStatus>('');
  const { data, loading, error, refetch } = useProjects(status || undefined);

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <label className="text-xs text-neutral-500">Status:</label>
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value as '' | ProjectStatus)}
          className="border rounded px-2 py-1 text-sm"
        >
          {STATUS_OPTIONS.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        <button onClick={refetch} className="text-xs underline">
          Refrescar
        </button>
      </div>

      {loading && !data && (
        <div className="text-sm text-neutral-500">Cargando proyectos…</div>
      )}
      {error && (
        <div className="text-sm text-red-600">Error: {error}</div>
      )}
      {data && data.length === 0 && (
        <div className="text-sm text-neutral-500">
          Sin proyectos. Acepta un quote para crear el primero.
        </div>
      )}
      {data && data.length > 0 && (
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead>
              <tr className="text-left border-b">
                <th className="px-3 py-2">Proyecto</th>
                <th className="px-3 py-2">Status</th>
                <th className="px-3 py-2">Hitos</th>
                <th className="px-3 py-2 text-right">Completado</th>
                <th className="px-3 py-2 text-right">Facturado</th>
                <th className="px-3 py-2">Moneda</th>
              </tr>
            </thead>
            <tbody>
              {data.map((p) => {
                const total = p.milestones.length;
                const done = p.milestones.filter((m) => m.status === 'done').length;
                const isSel = p.id === selectedId;
                return (
                  <tr
                    key={p.id}
                    onClick={() => onSelect(p.id)}
                    className={`border-b cursor-pointer ${
                      isSel ? 'bg-blue-50' : 'hover:bg-neutral-50'
                    }`}
                  >
                    <td className="px-3 py-2 font-medium">{p.name}</td>
                    <td className="px-3 py-2">{p.status}</td>
                    <td className="px-3 py-2">
                      {done}/{total}
                    </td>
                    <td className="px-3 py-2 text-right">
                      {p.amount_completed} {p.currency}
                    </td>
                    <td className="px-3 py-2 text-right">
                      {p.amount_billed} {p.currency}
                    </td>
                    <td className="px-3 py-2">{p.currency}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
